<template>
    <div class="qksm qksm6">
        <div class="nogap">
            <h4>二、重要事项说明</h4>
            <p><b>（一）政府采购情况</b></p>
            <p>
                2021年政府采购预算{{isMoney(T10.总计)}}万元，其中：
                <template v-for="(item, idx) in T10.项目">
                    {{item.name}}{{isMoney(item.value)}}万元{{idx==T10.项目.length-1?'；':'，'}}
                </template>
                其中：政府采购货物预算<reason type="money" classname="qksm money" name="政府采购货物" v-model:value="obj.货物"></reason>万元，
                政府采购工程预算<reason type="money" classname="qksm money" name="政府采购工程" v-model:value="obj.工程"></reason>万元，
                政府采购服务预算<reason type="money" classname="qksm money" name="政府采购服务" v-model:value="obj.服务"></reason>万元。
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm6",
        props: {
            T10: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
        data() {
            var qksm = this.$store.state.divData.qksm
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
                obj: {
                    总计: this.T10.总计,
                    货物: qksm['政府采购货物'],
                    工程: qksm['政府采购工程'],
                    服务: qksm['政府采购服务'],
                },
            }
        },
        created() {
            this.inspect()
        },
        updated: function () {
            this.inspect()
        },
        methods: {
            inspect() {
                var obj = Object.values(this.obj)
                var sum = 0;
                for (var i = 1; i < obj.length; i++) {
                    sum = sum + this.num(obj[i])
                }
                if (this.num(obj[0]) > 0 && this.num(obj[0]).toFixed(2) != this.num(sum).toFixed(2)) {
                    this.addOrSet("qksm21", "请检查本页《二、重要事项说明》中（一）政府采购情况，政府采购货物预算金额+政府采购工程预算金额+各政府采购服务预算金额应该等于政府采购预算总额。");
                } else {
                    this.remove("qksm21")
                }
            }
        }
    };
</script>